// extracted by mini-css-extract-plugin
export default {"conclusion":"joy-slogan_conclusion__ZP1u5","separatorBig":"joy-slogan_separatorBig__dk+Hk"};